<template>
  <v-text-field
      :key="moneyKey"
      ref="input_2"
      v-model="localValue"
      v-bind="$attrs"
      v-on="listeners"
      :hide-details="!hasErrors && !hint"
      :error-messages="hasErrors ? errors.list(errorName) : []"
      :append-icon="hasErrors ? '$informationOutline' : appendIcon"
      @blur="errors && errors.remove(errorName)"
      v-money="config"
      :height="height"
      :hint="hint"
      persistent-hint
      min="0"
      max="100"
  />
</template>

<script>
import { VMoney } from 'v-money';

export default {
  directives: {
    money: VMoney,
  },
  props: {
    value: {},
    maskConfig: Object,
    errors: {
      type: Object,
      required: false,
      default: () => null,
    },
    errorName: {
      type: String,
      required: false,
      default: '',
    },
    height: {
      type: [String, Number],
      required: false,
      default: undefined,
    },
    appendIcon: {
      type: String,
      required: false,
      default: () => undefined,
    },
    hint: {
      type: String,
      required: false,
      default: () => undefined,
    },
  },
  data: (vm) => ({
    moneyKey: Date.now(),
    localValue: 0,
    lastNumber: null,
  }),
  methods: {
    focus() {
      this.$refs.input_2.focus();
    },
  },
  computed: {
    listeners() {
      const { input, ...listeners } = this.$listeners;
      return { ...listeners };
    },
    hasErrors() {
      return this.errors && this.errors.has(this.errorName);
    },
    config() {
      const mask = {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '%',
        precision: 2,
      };

      return this.maskConfig || mask;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler: function(newValue) {
        if (newValue == null) {
          this.$emit('input', 0);
          return;
        }

        if (this.lastNumber == null || this.lastNumber != newValue) {
          this.moneyKey = Date.now();

          this.lastNumber = newValue;
          this.localValue = (newValue).toFixed(this.config.precision);
        }
      },
    },
    localValue(newValue) {
      if (this.lastNumber == null) return;

      let inputValue = newValue.replace(this.config.prefix, '').replace(this.config.suffix, '').trim();

      if (this.config.thousands) {
        const thousands = new RegExp(`\\${this.config.thousands}`, 'g');
        inputValue = inputValue.replace(thousands, '');
      }

      if (this.config.precision > 0) {
        inputValue = inputValue.replace(this.config.decimal, '.');
      }

      inputValue = Number(inputValue);

      this.lastNumber = inputValue;
      this.$emit('input', inputValue);
    },
  },
}
</script>
